// src/constants/api.constants.ts

/**
 * Base URL of the backend API.
 *
 * Previously every service (and several components) inlined
 * `process.env.REACT_APP_API_URL || "http://localhost:8080"` — the same
 * fallback was copy-pasted dozens of times. Centralizing it here means the dev
 * fallback and the env-var name live in exactly one place.
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";
